import FeatureSettingsService from './featureSettingsService';
import {featureFlags} from './featureFlags.const';

export default class NavigationService{
    static goToWebappUrl(url, appName, params){
        appName = appName ? appName : 'online';
        if (FeatureSettingsService.isFeatureEnabled(featureFlags.WebappPreviewEnabled) && appName === 'online') {
            appName = 'preview/online';
        }
        let allParams = this.getAllQueryParameters(params);
        let href = this.combineHref(url, appName, allParams);
        window.location.href = href;
    }

    static goToRoot(params){
        let allParams = this.getAllQueryParameters(params);
        let href = this.combineHref('', '', allParams);
        window.location.href = href;
    }

    static generateLinkHref(url, appName, params) {
        let allParams = this.getAllQueryParameters(params);
        return this.combineHref(url, appName, allParams);
    }

    static getAllQueryParameters(params) {
        let allParams = '';
        if (!params) {
            return allParams;
        }
        for (const [key, value] of Object.entries(params)) {
            if (value) {
                allParams += `&${key}=${encodeURIComponent(value)}`;
            }
        }
        if (allParams.length) {
            allParams = "?" + allParams.substring(1);
        }

        return allParams;
    }

    static combineHref(url, appName, allParams) {
        const protocol = window.location.protocol;
        const domain = window.location.hostname;
        let port = '';
        let href;
        switch (process.env.NODE_ENV) {
            case 'development': {
                port = ':4000';
                href = protocol + '//' + domain + port + '/' + appName + url + allParams;
                break;
            }
            default: {
                href = protocol + '//' + domain + process.env.baseHref + '/' + appName + url + allParams;
                break;
            }
        }

        return href;
    }
}



// WEBPACK FOOTER //
// ./src/scripts/services/navigation.js